module.exports = __webpack_public_path__ + "static/media/HelveticaNeueCyr-Thin.c3cf0c17.woff";